import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import { NumberInput as BaseNumberInput } from 'foundations-components/transitional/components/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const NumberInput = ({
  autoFocus,
  disabled,
  format,
  id,
  increment,
  max,
  min,
  onChange,
  placeholder,
  readOnly,
  value,
  required
}) => {
  const inputProps = {
    autoFocus,
    disabled,
    id,
    max: max || undefined,
    min: min || undefined,
    format,
    onChange: e => onChange(e.target.value),
    placeholder,
    readOnly,
    value,
    required
  };
  if (increment) {
    return /*#__PURE__*/_jsx(StepperInput, Object.assign({
      tabIndex: 0
    }, inputProps, {
      stepSize: increment
    }));
  }
  return /*#__PURE__*/_jsx(BaseNumberInput, Object.assign({
    tabIndex: 0
  }, inputProps));
};